import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Navbar.css';

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  function handleLogout() {
    logout();
    navigate('/login');
  }

  return (
    <nav className="navbar">
      <div className="navbar-inner page-wrapper">
        <Link to="/events" className="navbar-brand">
          <span className="brand-icon">⬡</span>
          Mediaxone
        </Link>

        {user ? (
          <div className="navbar-actions">
            <Link to="/upload" className="btn btn-primary">+ Upload</Link>
            <Link to="/settings" className="btn btn-ghost">Settings</Link>
            <span className="navbar-user">{user.name}</span>
            <button className="btn btn-ghost" onClick={handleLogout}>Sign out</button>
          </div>
        ) : (
          <div className="navbar-actions">
            <Link to="/login" className="btn btn-ghost">Sign in</Link>
            <Link to="/register" className="btn btn-primary">Get started</Link>
          </div>
        )}
      </div>
    </nav>
  );
}
